import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { MonitorBoardBreakdownPage } from '@/features/question/pages/MonitorBoardBreakdownPage';
import { monitorClassesSearchSchema } from '@/features/question/types/question.types';

export const Route = createFileRoute('/_auth/question/monitor/classes')({
  validateSearch: monitorClassesSearchSchema,
  component: function MonitorClassesRoute() {
    const search = Route.useSearch();
    return (
      <ErrorBoundary moduleName="Class wise Question Monitor">
        <Suspense fallback={<PageLoader />}>
          <MonitorBoardBreakdownPage groupBy="class" search={search} />
        </Suspense>
      </ErrorBoundary>
    );
  },
});
